import { type FlattenSimpleInterpolation, css } from "styled-components";
import { TextAlignment, Variant } from "../TextProps";
import type { ILinkProps } from "./Link.types";

export const LinkStyles = (props: ILinkProps): FlattenSimpleInterpolation => {
  const fontSize = props.variant === Variant.SMALL ? `0.875rem` : `1rem`;
  const letterSpacing =
      props.variant === Variant.SMALL ? "0.0175rem" : "0.02rem";
  const textAlign = props.alignment ?? TextAlignment.INHERIT;
  const color = props.textColor ?? "var(--colour-black)";
  return css`
      font-family: var(--font-helvetica);
      font-size: ${fontSize};
      font-weight: 700;
      line-height: 1.5;
      letter-spacing: ${letterSpacing};
      text-transform: initial;
      text-align: ${textAlign};
      color: ${color};
      word-break: break-word;
      position: relative;
      text-decoration: none;
      background-image: linear-gradient(${color}, ${color});
      background-position: 0% calc(100% - 2px);
      background-repeat: no-repeat;
      background-size: 100% 1px;
      transition: background-size .3s;

      &:hover, &:focus {
          background-size: 0% 1px;
      }
  `;
};
